import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { compose } from "redux";
import SubCategoryList from "./SubCategoryList";
import SubCategoryForm from "./SubCategoryForm";
import { ADD_NEW } from "constants/commonConstants";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import categoryReducer from "store/Masters/Category/reducer";
import categorySaga from "store/Masters/Category/saga";

const categoryKey = "CategoryMaster";

const withCategoryReducer = injectReducer({
  key: categoryKey,
  reducer: categoryReducer,
});
const withCategorySaga = injectSaga({ key: categoryKey, saga: categorySaga });

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDialog: false,
      subCategoryData: null,
    };

    this.validator = new SimpleReactValidator();
  }

  onSubCategoryInsertUpdateSuccess = () => {
    this.setState({
      formDialog: false,
      subCategoryData: null,
    });
  };

  viewSubCategory = (subCategory) => {
    this.setState({
      formDialog: true,
      subCategoryData: subCategory,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          <SubCategoryForm
            formDialog={this.state.formDialog}
            subCategoryRecord={this.state.subCategoryData}
            closeModal={() => this.onSubCategoryInsertUpdateSuccess()}
          ></SubCategoryForm>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between flex-column flex-sm-row">
                    <h4 className="mt-0 page-title">Sub Category</h4>
                    <button
                      className="my-2 btn btn-primary waves-effect waves-light float-right"
                      onClick={() => this.viewSubCategory(null)}
                    >
                      {ADD_NEW}
                    </button>
                  </div>

                  <SubCategoryList
                    onViewSubCategory={(subCategoryValues) =>
                      this.viewSubCategory(subCategoryValues)
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default compose(
  withCategoryReducer,
  withCategorySaga,
  withRouter
)(Index);
//export default withRouter(withConnect)(Index);
